<template>
  <div class="vote-result-info">
    <el-dialog v-if="dialogVisibleInfo&&type === 'info'" v-el-drag-dialog :title="$tx('hygl.voteManage.votoDetail')" :visible.sync="dialogVisibleInfo" width="850px" @close="dialogVisibleInfo = false">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$tx('hygl.voteManage.isVoto','已投票')" name="first">
          <have-vote-component :id="id" :row="row" class="haveVote" />
        </el-tab-pane>
        <el-tab-pane :label="$tx('hygl.voteManage.noVoto','未投票')" name="second">
          <not-vote-component :id="id" class="notVote" />
        </el-tab-pane>
        <el-tab-pane :label="$tx('hygl.voteManage.votoTotal','投票统计')" name="third">
          <statistics-vote :id="id" class="sta" @exportDataFmt="exportDataFmt" />
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" plain @click="dialogVisibleInfo = false"> 关 闭 </el-button>
        <el-button v-show="activeName === 'first'" v-pageBtn-lbl="'download'" type="primary" icon="el-icon-download" @click="downloadHandler(1)"> 下 载 </el-button>
        <el-button v-show="activeName === 'second'" v-pageBtn-lbl="'download'" type="primary" icon="el-icon-download" @click="downloadHandler(2)"> 下 载 </el-button>
        <el-button v-show="activeName === 'third'" v-pageBtn-lbl="'download'" file-name="投票明细" type="primary" icon="el-icon-download" @click="DonloadInfo()"> 下 载 </el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="dialogVisibleInfo&&type === 'code'" :title="$tx('hygl.voteManage.votoScan2')" :visible.sync="dialogVisibleInfo" width="850px" @close="dialogVisibleInfo = false">
      <vote-qr-code :row="row" @getQrCodeSrc="getQrCodeSrc" />
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'close'" plain icon="el-icon-close" @click="dialogVisibleInfo = false"> 关 闭 </el-button>
        <el-button v-pageBtn-lbl="'download'" type="primary" icon="el-icon-download" @click="DonloadCode"> 下 载 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import haveVoteComponent from './haveVoteComponent'
import notVoteComponent from './notVoteComponent'
import statisticsVote from './statisticsVote'
import voteQrCode from './voteQrCode'
import qs from 'qs'
export default {
    name: 'Votefrom',
    components: {
        haveVoteComponent,
        notVoteComponent,
        statisticsVote,
        voteQrCode

    },
    props: {
        // dialogVisibleInfo: { type: String, default: function() { return '' } },
        // row: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            dialogVisibleInfo: false,
            activeName: 'first',
            type: '',
            row: {},
            QrCodeSrc: '',
            tabindex: '',
            exportData: ''
        }
    },
    computed: {

    },
    created() {
        this.$bus.on('openVoteform', this.eg)
    },
    beforeDestroy() {
        this.$bus.off('openVoteform', this.eg)
    },
    mounted() {
    },
    methods: {
        getQrCodeSrc(url) {
            this.QrCodeSrc = url
        },
        exportDataFmt(data) {
            this.exportData = data
        },
        eg(row, type) {
            this.dialogVisibleInfo = true
            this.id = row.id
            this.activeName = 'first'
            this.type = type
            this.row = row
        },
        downloadHandler(type) {
            if (Number(type) === 1) {
                window.open(`/apigw/hygl/voteResult/exportdata?pageSize=65000&pageNum=1&listpageId=85336684cbd14c1380395858b3893390&searchAndOr=&fileName=投票明细-已投票&httpPort=${location.port}&urlsearch=choiceStatus:2;voteId:${this.id};status:1`)
            } else {
                window.open(`/apigw/hygl/voteResult/exportdata?pageSize=65000&pageNum=1&listpageId=85336684cbd14c1380395858b3893390&searchAndOr=&fileName=投票明细-未投票&httpPort=${location.port}&urlsearch=choiceStatus:1;voteId:${this.id};status:1`)
            }
        },
        DonloadInfo() {
            const data = this.exportData
            const rows = []// 数据集
            for (let i = 0; i < data.length; i++) {
                const row = []// 数据行
                row.push({ 'value': data[i], 'align': 'left', 'colspan': 1, 'rowspan': 1 })
                rows.push(row)
            }
            const fileName = '投票明细'
            const titles = [[{ 'title': '投票统计', 'width': 1, 'align': 'center', 'colspan': 1, 'rowspan': 1 }]]
            this.$vnode.context.$http({
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                data: qs.stringify({ 'rows': JSON.stringify(rows), 'titles': JSON.stringify(titles), 'fileName': fileName }),
                url: 'common/exportXlsFile'
            }).then(res => {
                if (res.code === 'success') {
                    window.open(encodeURI('/apigw/' + res.body.xlsurl), '_blank')
                } else {
                    this.$vnode.context.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        DonloadCode() {
            const image = new Image()
            // 解决跨域 Canvas 污染问题
            image.setAttribute('crossOrigin', 'anonymous')
            image.onload = function() {
                const canvas = document.createElement('canvas')
                canvas.width = image.width
                canvas.height = image.height
                const context = canvas.getContext('2d')
                context.drawImage(image, 0, 0, image.width, image.height)
                const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
                const elink = document.createElement('a') // 生成一个a元素
                elink.style.display = 'none'
                elink.href = url // 将生成的URL设置为a.href属性
                elink.download = name || 'pic' // 设置图片名称
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
                URL.revokeObjectURL(url)
            }
            image.src = this.QrCodeSrc
        }
    }
}
</script>

<style scoped lang="scss">
.vote-result-info{
  /deep/ .el-table-toolbar{ display: none; }
}
</style>
